import { ASSETS } from './assets-data.js';

const AboutData = {
    en: {
        seo: {
            title: 'About Tropical Marine Construction | Cape Coral Marine Contractor',
            description: 'Tropical Marine Construction of SWFL is a trusted Cape Coral marine contractor specializing in docks, boat lifts, seawalls, pilings, tiki huts, and waterfront construction.',
            keywords: 'Tropical Marine Construction, Cape Coral dock builder, SWFL marine contractor, boat lift installation, dock construction, seawall repair'
        },

        heroSection: {
            title: 'Built for Life on the Water',
            description: 'Tropical Marine Construction helps waterfront property owners design, build, repair, and upgrade docks, boat lifts, seawalls, pilings, and outdoor marine structures across Cape Coral and Southwest Florida.',
            ctaPrimary: 'Get a Free Estimate',
            ctaSecondary: 'View Our Work',
            media: ASSETS.LANDINGPAGEVIDEOTROPICAL || ASSETS.DOCKS_1 || '',
        },

        whatWeDoSection: {
            label: 'WHAT WE DO',
            title: 'Complete Marine Construction for Waterfront Properties',
            lead: 'From new dock builds to boat lift installation and seawall repairs, we handle the work that protects and improves your waterfront lifestyle.',
            image: ASSETS.WHATSAPP_IMAGE_2026_05_01_AT_03_25_04_3 || ASSETS.BOATLIFTS_1 || '',
            items: [
                'Custom Dock Design & Construction',
                'Boat Lift Installation, Repair & Maintenance',
                'Deck, Dock & Piling Repairs',
                'Seawall & Waterfront Anchor Wall Repairs',
                'PWC, Jet Ski, Kayak & Floating Dock Solutions',
            ],
            body: 'We focus on clean workmanship, proper permitting, reliable communication, and marine-grade construction that is built for Florida waterfront conditions.',
        },

        whyChooseUsSection: {
            label: 'WHY CHOOSE US',
            titleLine1: 'Marine Work Done Right.',
            titleLine2: 'From Permit to Final Build.',
            subtitle: 'A LOCAL TEAM BUILT AROUND WATERFRONT CONSTRUCTION, REPAIRS, AND LONG-TERM RELIABILITY.',
            cards: [
                {
                    image: ASSETS.BADGE_LOGO || ASSETS.TROPICAL_MARINE_CONSTRUCTION_LOGO || '',
                    title: 'Licensed & Insured',
                    description: 'Florida Certified Building Contractor License #CBC1260600.',
                },
                {
                    image: ASSETS.TROPICAL_MARINE_LOGO || ASSETS.TROPICAL_MARINE_CONSTRUCTION_LOGO || '',
                    title: '30+ Years Experience',
                    description: 'Serving Cape Coral, Lee County, and Southwest Florida waterfront properties.',
                },
                {
                    image: ASSETS.DOCKS_2 || ASSETS.DOCKS_1 || '',
                    title: 'Custom Waterfront Builds',
                    description: 'Docks, lifts, seawalls, pilings, decks, and outdoor marine structures.',
                },
                {
                    image: ASSETS.BOATLIFTS_1 || ASSETS.DOCKS_3 || '',
                    title: 'Built to Last',
                    description: 'Marine-grade materials, proper permits, approved drawings, and dependable workmanship.',
                },
            ],
        },

        ourApproachSection: {
            label: 'OUR APPROACH',
            title: 'We Build Around Your Property, Your Boat, and Your Waterfront Goals.',
            paragraphs: [
                { text: 'Every waterfront property is different.' },
                { text: 'That is why we start with the site, the water conditions, the structure, and your real usage needs.' },
                { text: 'We help with ', bold: 'planning, permitting, construction, repair, and final inspection.' },
                { text: 'The result is a marine project that looks right, functions properly, and is built for long-term use.' },
            ],
            quote: 'Your dock, lift, or seawall should make waterfront living easier — not more stressful.',
        },

        wholesalePartnerSection: {
            title: 'Your Local Partner\nfor Waterfront Construction',
            body: 'Whether you need a new dock, a boat lift, a repair, or a full waterfront upgrade —',
            bodyBold: 'Tropical Marine Construction is built to manage the project from start to finish.',
            tagline: 'Reliable. Local. Built for the Water.',
        },

        capabilitiesSection: {
            title: 'Marine Construction Services',
            cards: [
                {
                    id: 'docks',
                    tag: 'Docks',
                    img: ASSETS.DOCKS_1 || '',
                    title: 'Dock Design & Construction',
                    description: 'Custom boat docks, decks, floating docks, kayak docks, and waterfront access structures designed around your property.',
                },
                {
                    id: 'boat-lifts',
                    tag: 'Boat Lifts',
                    img: ASSETS.BOATLIFTS_1 || '',
                    title: 'Boat Lift Installation & Repair',
                    description: 'Boat lifts, PWC lifts, jet ski lifts, used lift sales, installation, maintenance, and repair services.',
                },
                {
                    id: 'seawalls',
                    tag: 'Repairs',
                    img: ASSETS.DOCKS_2 || '',
                    title: 'Seawalls, Pilings & Repairs',
                    description: 'Piling installation, dock repairs, deck repairs, seawall repairs, and waterfront anchor wall repairs.',
                },
            ],
        },

        teamSection: {
            title: 'A Local Marine Construction Team',
            description: 'Our team manages the full project process — consultation, design, permitting, construction, repairs, and final inspection.',
            ctaPrimary: 'Contact Us',
            members: [
                {
                    name: 'Tropical Marine Construction',
                    role: 'Marine Construction Specialists',
                    img: ASSETS.TROPICAL_MARINE_CONSTRUCTION_LOGO || ASSETS.TROPICAL_MARINE_LOGO || '',
                    email: 'info@tropicalmarineconstruction.com',
                },
            ],
        },

        processSection: {
            label: 'OUR MISSION',
            title: 'Turning Waterfront Ideas Into Strong, Reliable Marine Structures',
            subtitle: 'From docks and boat lifts to seawalls and repairs, we help Southwest Florida homeowners build with confidence.',
            backgroundImage: ASSETS.WHATSAPP_IMAGE_2026_05_01_AT_03_25_04_6 || ASSETS.DOCKS_4 || '',
            buttonText: 'Get a Free Estimate',
            disclaimer: '* Florida Certified Building Contractor License #CBC1260600. Fully licensed and insured.',
        },

        servicesList: [
            'Boat Decks and Docks Design and Construction',
            'Boat Lift Installation',
            'Boat Lift Repair and Maintenance',
            'Deck and Dock Repairs',
            'Piling Installation',
            'PWC and Jet Ski Lift Installation',
            'PWC and Jet Ski Lift Repair and Maintenance',
            'Seawall and Waterfront Anchor Wall Repairs',
            'Outdoor Thatched Tiki Hut Design and Construction',
            'Kayak Docks and Floating Docks Construction and Repair',
            'Used Boat Lifts Purchase and Sale',
        ],
    },

    he: {
        seo: {
            title: 'About Tropical Marine Construction | Cape Coral Marine Contractor',
            description: 'Tropical Marine Construction of SWFL is a trusted Cape Coral marine contractor specializing in docks, boat lifts, seawalls, pilings, tiki huts, and waterfront construction.',
            keywords: 'Tropical Marine Construction, Cape Coral dock builder, SWFL marine contractor, boat lift installation, dock construction, seawall repair'
        },

        heroSection: {
            title: 'Built for Life on the Water',
            description: 'Tropical Marine Construction helps waterfront property owners design, build, repair, and upgrade docks, boat lifts, seawalls, pilings, and outdoor marine structures across Cape Coral and Southwest Florida.',
            ctaPrimary: 'Get a Free Estimate',
            ctaSecondary: 'View Our Work',
            media: ASSETS.LANDINGPAGEVIDEOTROPICAL || ASSETS.DOCKS_1 || '',
        },

        whatWeDoSection: {
            label: 'WHAT WE DO',
            title: 'Complete Marine Construction for Waterfront Properties',
            lead: 'From new dock builds to boat lift installation and seawall repairs, we handle the work that protects and improves your waterfront lifestyle.',
            image: ASSETS.DOCKS_1 || ASSETS.BOATLIFTS_1 || '',
            items: [
                'Custom Dock Design & Construction',
                'Boat Lift Installation, Repair & Maintenance',
                'Deck, Dock & Piling Repairs',
                'Seawall & Waterfront Anchor Wall Repairs',
                'PWC, Jet Ski, Kayak & Floating Dock Solutions',
            ],
            body: 'We focus on clean workmanship, proper permitting, reliable communication, and marine-grade construction that is built for Florida waterfront conditions.',
        },

        whyChooseUsSection: {
            label: 'WHY CHOOSE US',
            titleLine1: 'Marine Work Done Right.',
            titleLine2: 'From Permit to Final Build.',
            subtitle: 'A LOCAL TEAM BUILT AROUND WATERFRONT CONSTRUCTION, REPAIRS, AND LONG-TERM RELIABILITY.',
            cards: [
                {
                    image: ASSETS.BADGE_LOGO || ASSETS.TROPICAL_MARINE_CONSTRUCTION_LOGO || '',
                    title: 'Licensed & Insured',
                    description: 'Florida Certified Building Contractor License #CBC1260600.',
                },
                {
                    image: ASSETS.TROPICAL_MARINE_LOGO || ASSETS.TROPICAL_MARINE_CONSTRUCTION_LOGO || '',
                    title: '30+ Years Experience',
                    description: 'Serving Cape Coral, Lee County, and Southwest Florida waterfront properties.',
                },
                {
                    image: ASSETS.DOCKS_2 || ASSETS.DOCKS_1 || '',
                    title: 'Custom Waterfront Builds',
                    description: 'Docks, lifts, seawalls, pilings, decks, and outdoor marine structures.',
                },
                {
                    image: ASSETS.BOATLIFTS_1 || ASSETS.DOCKS_3 || '',
                    title: 'Built to Last',
                    description: 'Marine-grade materials, proper permits, approved drawings, and dependable workmanship.',
                },
            ],
        },

        ourApproachSection: {
            label: 'OUR APPROACH',
            title: 'We Build Around Your Property, Your Boat, and Your Waterfront Goals.',
            paragraphs: [
                { text: 'Every waterfront property is different.' },
                { text: 'That is why we start with the site, the water conditions, the structure, and your real usage needs.' },
                { text: 'We help with ', bold: 'planning, permitting, construction, repair, and final inspection.' },
                { text: 'The result is a marine project that looks right, functions properly, and is built for long-term use.' },
            ],
            quote: 'Your dock, lift, or seawall should make waterfront living easier — not more stressful.',
        },

        wholesalePartnerSection: {
            title: 'Your Local Partner\nfor Waterfront Construction',
            body: 'Whether you need a new dock, a boat lift, a repair, or a full waterfront upgrade —',
            bodyBold: 'Tropical Marine Construction is built to manage the project from start to finish.',
            tagline: 'Reliable. Local. Built for the Water.',
        },

        capabilitiesSection: {
            title: 'Marine Construction Services',
            cards: [
                {
                    id: 'docks',
                    tag: 'Docks',
                    img: ASSETS.DOCKS_1 || '',
                    title: 'Dock Design & Construction',
                    description: 'Custom boat docks, decks, floating docks, kayak docks, and waterfront access structures designed around your property.',
                },
                {
                    id: 'boat-lifts',
                    tag: 'Boat Lifts',
                    img: ASSETS.BOATLIFTS_1 || '',
                    title: 'Boat Lift Installation & Repair',
                    description: 'Boat lifts, PWC lifts, jet ski lifts, used lift sales, installation, maintenance, and repair services.',
                },
                {
                    id: 'seawalls',
                    tag: 'Repairs',
                    img: ASSETS.DOCKS_2 || '',
                    title: 'Seawalls, Pilings & Repairs',
                    description: 'Piling installation, dock repairs, deck repairs, seawall repairs, and waterfront anchor wall repairs.',
                },
            ],
        },

        teamSection: {
            title: 'A Local Marine Construction Team',
            description: 'Our team manages the full project process — consultation, design, permitting, construction, repairs, and final inspection.',
            ctaPrimary: 'Contact Us',
            members: [
                {
                    name: 'Tropical Marine Construction',
                    role: 'Marine Construction Specialists',
                    img: ASSETS.TROPICAL_MARINE_CONSTRUCTION_LOGO || ASSETS.TROPICAL_MARINE_LOGO || '',
                    email: 'info@tropicalmarineconstruction.com',
                },
            ],
        },

        processSection: {
            label: 'OUR MISSION',
            title: 'Turning Waterfront Ideas Into Strong, Reliable Marine Structures',
            subtitle: 'From docks and boat lifts to seawalls and repairs, we help Southwest Florida homeowners build with confidence.',
            backgroundImage: ASSETS.BOATLIFTS_1 || ASSETS.DOCKS_4 || '',
            buttonText: 'Get a Free Estimate',
            disclaimer: '* Florida Certified Building Contractor License #CBC1260600. Fully licensed and insured.',
        },

        servicesList: [
            'Boat Decks and Docks Design and Construction',
            'Boat Lift Installation',
            'Boat Lift Repair and Maintenance',
            'Deck and Dock Repairs',
            'Piling Installation',
            'PWC and Jet Ski Lift Installation',
            'PWC and Jet Ski Lift Repair and Maintenance',
            'Seawall and Waterfront Anchor Wall Repairs',
            'Outdoor Thatched Tiki Hut Design and Construction',
            'Kayak Docks and Floating Docks Construction and Repair',
            'Used Boat Lifts Purchase and Sale',
        ],
    },
};

export function getAboutData(language) {
    return AboutData[language === 'he' ? 'he' : 'en'];
}

export default AboutData;